import { takeEvery, fork, put, all, call } from "redux-saga/effects";

// Skills Redux States
import { GET_SKILLS, GET_SKILL } from "./actionTypes";
import { loadSkills, apiError, setSkill } from "./actions";
//Include Both Helper File with needed methods
import axios from "axios";

function* getSkills({ payload: { idCompany, page, qnt } }) {
  //TODO: get client_id from company
  try {
    const response = yield call(
      axios.get,
      `/skill${
        idCompany
          ? `?client_id=${idCompany}
          ${page && qnt ? `&page=${page}&qnt=${qnt}` : ""}`
          : ""
      }`
    );
    if (
      (response.status >= 200 || response.status <= 299) &&
      response.data &&
      response.data.data
    ) {
      yield put(loadSkills(response.data.data, qnt));
    } else throw response.data;
  } catch (error) {
    let message = error.message;
    if (error.response && error.response.status) {
      //TODO: Incluir os tratamento necessário para apresentar os erros corretos
      switch (error.response.status) {
        case 400:
          message = "Invalid data";
          break;
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          message = "Sorry! the page you are looking for could not be found";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}
function* getSkill({ payload: { clientId, idSkill } }) {
  try {
    const response = yield call(
      axios.get,
      `/skill${
        clientId && idSkill ? `?client_id=${clientId}&id=${idSkill}` : ""
      }`,
      {}
    );
    if (
      (response.status >= 200 || response.status <= 299) &&
      response.data &&
      response.data.data
    ) {
      yield put(setSkill(response.data.data));
    } else throw response.data;
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      //TODO: Incluir os tratamento necessário para apresentar os erros corretos
      switch (error.response.status) {
        case 400:
          message = "Invalid data";
          break;
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          message = "Sorry! the page you are looking for could not be found";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}
export function* watchSkill() {
  yield takeEvery(GET_SKILLS, getSkills);
}
export function* watchGetSkill() {
  yield takeEvery(GET_SKILL, getSkill);
}
function* authSaga() {
  yield all([fork(watchSkill), fork(watchGetSkill)]);
}

export default authSaga;
